let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("inRTA")).then(() => parcelRequire('5PH0x'));